import { handleError } from "../../../../utils/handleError";
const deleteEditorNode = async (
  editor,
  nodeName,
  nodeAttributes,
  options = {}
) => {
  try {
    if (!editor) editor = fp.editor;
    if (editor) {
      // Yield once, so a node view that asks for its own deletion from inside
      // its render or effect has returned before the view it lives in is torn
      // down. A microtask, not a guessed delay: nothing else needs to happen
      // first. The position is read after the yield, so it is the current
      // one (it used to be read before a 100 ms sleep, #12187).
      await Promise.resolve();
      const node = editor.$node(nodeName, nodeAttributes);
      if (node) {
        const nodePosition = node.pos;
        if (typeof nodePosition === "number") {
          try {
            editor
              .chain()
              .setNodeSelection(nodePosition - 1)
              .run();

            if (editor.state.selection.node.type.name === nodeName) {
              editor
                .chain()
                .setNodeSelection(nodePosition - 1)
                .deleteSelection()
                .run();
              if (options.bringBackCursor) {
                editor.chain().focus().run();
              }
              return;
            }
          } catch (error) {
            console.log("nodePosition-1 did not work. Will try nodePosition");
          }

          try {
            editor.chain().setNodeSelection(nodePosition).run();

            if (editor.state.selection.node.type.name === nodeName) {
              editor
                .chain()
                .setNodeSelection(nodePosition)
                .deleteSelection()
                .run();

              if (options.bringBackCursor) {
                editor.chain().focus().run();
              }
              return;
            }
          } catch (error) {
            console.log("nodePosition did not work. Will try nodePosition + 1");
          }

          try {
            editor
              .chain()
              .setNodeSelection(nodePosition + 1)
              .run();

            if (editor.state.selection.node.type.name === nodeName) {
              editor
                .chain()
                .setNodeSelection(nodePosition + 1)
                .deleteSelection()
                .run();
              if (options.bringBackCursor) {
                editor.chain().focus().run();
              }
              return;
            }
          } catch (error) {
            console.error("error", error);
          }
        }
      }
    }
  } catch (error) {
    handleError({
      error,
      location: "deleteEditorNode",
    });
  }
};

const updateEditorNode = async (
  editor,
  nodeName,
  nodeAttributes,
  newNodeAttributes
) => {
  try {
    // Use the provided editor instance or fallback to fp.editor
    if (!editor) editor = fp.editor;

    if (editor) {
      // Retrieve all nodes of the specified type and attributes
      const nodes = editor.$nodes(nodeName, nodeAttributes);

      if (nodes.length > 0) {
        // Iterate over each matching node
        for (const node of nodes) {
          // Select the node by creating a NodeSelection at its position
          editor.commands.setNodeSelection(node.pos);

          // Update the node's attributes
          // Synchronous: the document holds the new attributes when this
          // returns, so there is nothing to wait for after it (#12187).
          editor.commands.updateAttributes(nodeName, newNodeAttributes);

          console.log(
            `Updated attributes of node '${nodeName}' from`,
            nodeAttributes,
            "to",
            newNodeAttributes
          );
        }
      } else {
        console.log(
          `No matching nodes found for '${nodeName}' with attributes`,
          nodeAttributes
        );
      }
    } else {
      console.log("Editor instance not found");
    }
  } catch (error) {
    handleError({
      error,
      location: "updateEditorNode",
    });
  }
};

export { deleteEditorNode, updateEditorNode };
